// Locksmith hides wholesale sizes (e.g. Case of 6) from the picker but they
// remain in the variant JSON. Impulse VariantAvailability then queries a
// missing node and throws, so later sold-out sizes never get .disabled.
(function () {
  function patch() {
    if (!window.theme || !theme.VariantAvailability || !theme.VariantAvailability.prototype) return false;
    var proto = theme.VariantAvailability.prototype;
    if (proto.enableVariantOption._emberSkipMissing) return true;
    var original = proto.enableVariantOption;
    proto.enableVariantOption = function (group, obj) {
      if (!group || !obj || obj.value == null) return;
      try {
        return original.call(this, group, obj);
      } catch (err) {
        return;
      }
    };
    proto.enableVariantOption._emberSkipMissing = true;
    return true;
  }

  if (!patch()) {
    document.addEventListener('DOMContentLoaded', patch);
  }
})();
